import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Link from '../common/TrackedLink';
import { branch } from 'baobab-react/higher-order';
import request from 'superagent';
import Autosuggest from 'react-autosuggest';
import classNames from 'classnames';
import MobileNav from './MobileNav';
import {PRODUCT_SELECTOR} from "../../constants/app";
import {dataLayerPush} from "../../utils";
import {pushLinkItem, pushMenuItem} from "../../utils/datalayer";
//import logo from '../../resources/img/sentry-safe-logo.png';
//import logo2x from '../../resources/img/sentry-safe-logo@2x.png';

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			options: [],
			selected: null,
			mobileMenu: false,
			mobileSearch: false,
			redirect: false,
			productsNavCurrentClass: '',
			learnNavCurrentClass: '',
			whereToBuyNavCurrentClass: '',
			supportNavCurrentClass: '',
			submitFormOnEnter: true,
			value: '',
			suggestions: [],
			isLoading: false,
			currentLocation: ''
		};

		this.lastRequestId = null;
	}

	//start autosuggest
	loadSuggestions(value) {
		// Cancel the previous request
		if (this.lastRequestId !== null) {
			clearTimeout(this.lastRequestId);
		}

		this.setState({
			isLoading: true
		});

		// start request
		if (!value) {
			return;
		}
		this.setState({ queryValue: value });
		this.lastRequestId = setTimeout(() => {
			request.get(`/api/sitesearch/lu?q=${value}`)
				.set('authorization', this.props.token)
				.then(resp => JSON.parse(resp.text))
				.then(siteSearch => {
					const options = siteSearch.keyLookups.map(keyword => keyword.label);
					this.setState({
						suggestions: options,
						isLoading: false
					});
				});
		}, 1000);
	}

	getSuggestionValue = suggestion => suggestion;

	onChange = (event, { newValue }) => {
		this.setState({
			value: newValue
		});
	};

	onSuggestionsFetchRequested = ({ value }) => {
		this.loadSuggestions(value);
	};

	onSuggestionsClearRequested = () => {
		this.setState({
			suggestions: []
		});
	};

	renderSuggestion(suggestion) {
		return (
			<Link to={`/search?q=${suggestion}&type=product`}>
				{suggestion}
			</Link>
		);
	}
	//end autosuggest

	componentDidMount() {
		this.setCurrentNav();
		this.updateSearchLocation();
	}

	componentWillReceiveProps() {
		this.setCurrentNav();
	}

	setCurrentNav() {
		const pathname = global.location.pathname;
		const isProductPage = (pathname.indexOf('/products') !== -1 &&
			pathname.indexOf('/videos/products') === -1) ||
			pathname.indexOf('/product/') !== -1 ||
			pathname.indexOf('-safes') !== -1 ||
			pathname.indexOf('cash-boxes') !== -1 ||
			pathname.indexOf('safe-selector') !== -1;
		const isLearnPage = pathname.indexOf('/learn') !== -1;
		const isWhereToBuyPage = pathname.indexOf('/where-to-buy') !== -1;
		const isSupportPage = pathname.indexOf('/support') !== -1;
		this.setState({
			productsNavCurrentClass: isProductPage ? 'current' : '',
			learnNavCurrentClass: isLearnPage ? 'current' : '',
			whereToBuyNavCurrentClass: isWhereToBuyPage ? 'current' : '',
			supportNavCurrentClass: isSupportPage ? 'current' : ''
		});
	}

	handleSearch(query) {
		if (!query) {
			return;
		}
		this.setState({ queryValue: query });
		request.get(`/api/sitesearch/lu?q=${query}`)
			.set('authorization', this.props.token)
			.then(resp => JSON.parse(resp.text))
			.then(siteSearch => {
				const options = siteSearch.keyLookups.map(keyword => keyword.label);
				this.setState({ options });
			});
	}

	handleSearchSubmit(event) {
		event.preventDefault();
		if (this.state.queryValue === undefined || this.state.queryValue === '' || this.state.queryValue.trim().length < 1) {
			return;
		}
		window.location = `/search?q=${this.state.queryValue}&type=product`;
		// window.history.pushState(null, null, `/search?q=${this.state.queryValue}&type=product`);
		// this.updateUrl();
		// this.setState({value: event.target.value});
	}

	handleChange(query) {
		this.setState({ queryValue: query });
		browserHistory.push(`/search?q=${query}&type=product`);
	}

	handleClick(data) {
		this.setState({
			selected: data,
			options: []
		});
	}

	toggleMobileNav() {
		if (this.state.mobileMenu === false) {
			this.setState({ mobileMenu: true });
		} else {
			this.setState({ mobileMenu: false });
		}
	}

	toggleMobileSearch() {
		if (this.state.mobileSearch === false) {
			this.setState({ mobileSearch: true });
		} else {
			this.setState({ mobileSearch: false });
		}
	}

	handleClickMobileNavToggle(e) {
		this.toggleMobileNav();
		let eventAction = 'expand';
		if (this.state.mobileMenu === true) {
			eventAction = 'collapse';
		}
		global.dataLayer.push({
			event: 'Mobile Header',
			eventCategory: 'Header',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	handleClickMobileSearchToggle(e) {
		this.toggleMobileSearch();
		let eventAction = 'expand';
		if (this.state.mobileSearch === true) {
			eventAction = 'collapse';
		}
		global.dataLayer.push({
			event: 'Mobile Header',
			eventCategory: 'Header',
			eventAction,
			eventLabel: e.currentTarget.textContent
		});
	}

	updateSearchLocation() {

	}

	handleMainMenuClick(e) {
		const target = e.currentTarget;

		const subNav = target.closest('.sub-nav');
		let menuPath;
		if (subNav) {
			const parent = subNav.previousSibling;
			menuPath = `${parent.textContent} > ${target.textContent}`;
		} else {
			menuPath = `${target.textContent}`;
		}
		pushMenuItem(e, 'Header | Main', menuPath);
	}

	handleUtilityMenuClick(e) {
		pushMenuItem(e, 'Header | Utility');
	}

	renderSearchBox() {
		const { value, suggestions } = this.state;
		let isHomePage = false;
		if (typeof global.location !== 'undefined') {
			const pathname = global.location.pathname;
			isHomePage = (pathname === "/") ? true : false;
		}

		const inputProps = {
			name: "Search",
			placeholder: "Search",
			value,
			onChange: this.onChange
		};

		const renderInputComponent = inputProps =>
			<div>
				<input itemProp="query-input" type="text" name="search_term_string" {...inputProps} />
			</div>;

		if (isHomePage) {
			return (
				<div
					itemScope=" "
					itemType="http://schema.org/WebSite"
				>
					<meta
						itemProp="url"
						content="https://www.sentrysafe.com/"
					/>
					<form
						className="header-search"
						onSubmit={this.handleSearchSubmit.bind(this)}
						itemProp="potentialAction"
						itemScope=" "
						itemType="http://schema.org/SearchAction"
					>
						<meta
							itemProp="target"
							content="https://query.sentrysafe.com/search?q={search_term_string}"
						/>
						<Autosuggest
							itemProp="query-input"
							name="search_term_string"
							suggestions={suggestions}
							onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
							onSuggestionsClearRequested={this.onSuggestionsClearRequested}
							getSuggestionValue={this.getSuggestionValue}
							renderSuggestion={this.renderSuggestion}
							renderInputComponent={renderInputComponent}
							inputProps={inputProps}
						/>
						<button
							onClick={this.handleSearchSubmit.bind(this)}
							className="btn-search"
						>
							<span className="fa fa-search fa-flip-horizontal sm-hide" aria-hidden="true" />
							<span className="assistive-text">
								Go <span className="fa fa-angle-right" aria-hidden="true" />
							</span>
						</button>
					</form>
				</div>
			);
		}
		else {
			return (
				<form
					className="header-search"
					onSubmit={this.handleSearchSubmit.bind(this)}
				>
					<Autosuggest
						suggestions={suggestions}
						onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
						onSuggestionsClearRequested={this.onSuggestionsClearRequested}
						getSuggestionValue={this.getSuggestionValue}
						renderSuggestion={this.renderSuggestion}
						inputProps={inputProps}
					/>
					<button
						onClick={this.handleSearchSubmit.bind(this)}
						className="btn-search"
					>
						<span className="fa fa-search fa-flip-horizontal sm-hide" aria-hidden="true" />
						<span className="assistive-text">
							Go <span className="fa fa-angle-right" aria-hidden="true" />
						</span>
					</button>
				</form>
			);
		}
	}

	render() {
		return (
			<header
				id="site-header"
				className={
					classNames({
						'mobile-nav-visible': this.state.mobileMenu,
						'mobile-search-visible': this.state.mobileSearch
					})
				}
			>
				<div className="row">
					<div className="col sm-2">
						<Link
							className="logo"
							id="headerLogo"
							to="/"
							onClick={(e) => {pushLinkItem(e, 'logo')}}
						>
							<img
								src={require('../../resources/img/sentry-safe-logo.png')}
								srcSet={require('../../resources/img/sentry-safe-logo@2x.png') + ' 2x'}
								alt="SentrySafe"
							/>
						</Link>
						<button
							type="button"
							className="nav-toggle"
							onClick={e => this.handleClickMobileNavToggle(e)}
						>
							<span className="fa fa-bars fa-2x" aria-hidden="true" />
							<span className="fa fa-close fa-2x" aria-hidden="true" />
							<span className="assistive-text">Menu</span>
						</button>
						<button
							type="button"
							className="search-toggle"
							onClick={e => this.handleClickMobileSearchToggle(e)}
						>
							<span className="fa fa-search fa-2x" aria-hidden="true" />
							<span className="assistive-text">Search</span>
						</button>
					</div>
					<div className="col sm-7">
						<nav className="site-nav sm-hide">
							<Link className="assistive-text" to="#content">Skip to content</Link>
							<ul className="nav" role="tablist">
								<li
									className={`nav-item nav-item-products ${this.state.productsNavCurrentClass}`}
									role="tab"
									tabIndex="0"
								>
									<span className="nav-header">Products</span>
									<ul className="sub-nav">
										<li>
											<Link
												to="/products"
												onClick={this.handleMainMenuClick}
											>
												All Products
											</Link>
										</li>
										<li>
											<a href={PRODUCT_SELECTOR.URL} target={PRODUCT_SELECTOR.TARGET}
										   		onClick={this.handleMainMenuClick}>
												{PRODUCT_SELECTOR.TEXT}
											</a>
										</li>
										<li>
											<Link
												to="/fire-waterproof-safes"
												onClick={this.handleMainMenuClick}
											>
												Water and Fireproof Safes
											</Link>
										</li>
										<li>
											<Link
												to="/security-safes"
												onClick={this.handleMainMenuClick}
											>
												Security Safes
											</Link>
										</li>
										<li>
											<Link
												to="/document-safes"
												onClick={this.handleMainMenuClick}
											>
												Document Safes
											</Link>
										</li>
										<li>
											<Link
												to="/pistol-safes"
												onClick={this.handleMainMenuClick}
											>
												Pistol Safes
											</Link>
										</li>
										<li>
											<Link
												to="/fire-safes"
												onClick={this.handleMainMenuClick}
											>
												Fire Safes and Fire Bags
											</Link>
										</li>
										<li>
											<Link
												to="/cash-boxes"
												onClick={this.handleMainMenuClick}
											>
												Cash Boxes
											</Link>
										</li>
										<li>
											<Link
												to="/business-safes"
												onClick={this.handleMainMenuClick}
											>
												Business Safes
											</Link>
										</li>
										<li>
											<Link
												to="/portable-safes"
												onClick={this.handleMainMenuClick}
											>
												Portable Safes
											</Link>
										</li>
									</ul>
								</li>
								<li
									className={`nav-item nav-item-learn ${this.state.learnNavCurrentClass}`}
									role="tab"
									tabIndex="0"
								>
									<span className="nav-header">Learn</span>
									<ul className="sub-nav">
										<li>
											<Link
												to="/learn/buying-guide"
												onClick={this.handleMainMenuClick}
											>
												Buying Guide
											</Link>
										</li>
										<li>
											<Link
												to="https://www.masterlock.com/insights"
												target="_blank"
												onClick={this.handleMainMenuClick}
											>
												Security and Safety Insights
											</Link>
										</li>
										{/*<li>*/}
										{/*	<Link*/}
										{/*		to="/learn/fire-and-water-safes"*/}
										{/*		onClick={this.handleMainMenuClick}*/}
										{/*	>*/}
										{/*		Fire and Water Safes*/}
										{/*	</Link>*/}
										{/*</li>*/}
										<li>
											<Link
												to="/learn/about-us"
												onClick={this.handleMainMenuClick}
											>
												About SentrySafe
											</Link>
										</li>
										<li>
											<Link
												to="/learn/customer-stories"
												onClick={this.handleMainMenuClick}
											>
												Stories
											</Link>
										</li>
									</ul>
								</li>
								<li className={`nav-item nav-item-where-to-buy ${this.state.whereToBuyNavCurrentClass}`}>
									<Link
										className="nav-link"
										to="/where-to-buy"
										onClick={this.handleMainMenuClick}
									>
										Where To Buy
									</Link>
								</li>
								<li className={`nav-item nav-item-buy-now-store`}>
									<Link
										className="nav-link"
										to="https://store.sentrysafe.com/"
										target="_blank"
										onClick={this.handleMainMenuClick}
									>
										Buy Now from Sentrysafe&#33;
									</Link>
								</li>
								<li
									className={`nav-item nav-item-support ${this.state.supportNavCurrentClass}`}
									role="tab"
									tabIndex="0"
								>
									<span className="nav-header">Support</span>
									<ul className="sub-nav">
										<li>
											<Link
												to="/support"
												onClick={this.handleMainMenuClick}
											>
												All Support
											</Link>
										</li>
										<li>
											<Link
												to="/support/find-your-model-or-serial-number"
												onClick={this.handleMainMenuClick}
											>
												Find Your Model or Serial Number
											</Link>
										</li>
										<li>
											<Link
												to="/support/faqs/how-do-i-change-the-batteries-on-my-safe"
												onClick={this.handleMainMenuClick}
											>
												Need Help with Your Digital Lock&#63;
											</Link>
										</li>
										<li>
											<Link
												to="/support/faqs"
												onClick={this.handleMainMenuClick}
											>
												FAQs
											</Link>
										</li>
										<li>
											<Link
												to="/support/lost-key-combo"
												onClick={this.handleMainMenuClick}
											>
												Lost Key or Combo
											</Link>
										</li>
										<li>
											<Link
												to="/support/videos"
												onClick={this.handleMainMenuClick}
											>
												Videos
											</Link>
										</li>
										<li>
											<Link
												to="/support/product-manuals"
												onClick={this.handleMainMenuClick}
											>
												Product Manuals
											</Link>
										</li>
										<li>
											<Link
												to="/support/contact-us"
												onClick={this.handleMainMenuClick}
											>
												Contact Us
											</Link>
										</li>
									</ul>
								</li>

							</ul>
						</nav>
					</div>
					<div className="col sm-3">
						<div className="text-right sm-hide">
							<ul className="utility-nav pt-md-1">
								<li>
									<Link
										to="https://www.masterlock.com/insights"
										className="insights-link"
										target="_blank"
										rel="noopener"
										onClick={this.handleUtilityMenuClick}
									>
										Insights
									</Link>

								</li>
								<li>
									<Link
										to="https://store.sentrysafe.com/collections/safe-accessories?_ga=2.90638618.1080419390.1543332157-424915552.1524584795"
										className="buy-now-link"
										target="_blank"
										rel="noopener"
										onClick={this.handleUtilityMenuClick}
									>
										Buy Accessories
									</Link>
								</li>
								<li>
									<Link
										to="https://www.registermysafe.com"
										className="register-link"
										target="_blank"
										rel="noopener"
										onClick={this.handleUtilityMenuClick}
									>
										Register My Safe
									</Link>
								</li>
							</ul>
						</div>
						{this.renderSearchBox()}
					</div>
				</div>

				<MobileNav
					isVisible={this.state.mobileMenu}
					toggleMobileNav={() => this.toggleMobileNav()}
				/>
			</header>
		);
	};
}

export default branch({
	token: ['token'],
	product: ['product']
}, Header);



// WEBPACK FOOTER //
// ./src/pages/components/Header.js